import { ModalManagerProvider, useContainer } from '@kawaui/modal-manager'
import { Unauth } from '@narf/unauth'
import { MessageCenterProvider } from '@user-engagement/custom-hooks'

import { ThirdPartyScripts } from 'components/oneTrust'
import { ABtestProvider, getExperiments } from 'context/abtest'
import { Auth2 } from 'context/auth2'

const getSessionMember = () => {
  if (typeof window === 'undefined') return undefined
  return JSON.parse(sessionStorage.getItem('veepeeMember'))
}

const getHeaderMember = (headers) => {
  if (!headers) return undefined
  const memberId = headers['x-vp-mid']
  const siteId = headers['x-vp-msite']
  // TODO(jose.mortola): siteId here is a str value should be parsed
  return { memberId, siteId }
}
const getHeadersMetadata = (headers) => {
  if (!headers) return undefined
  const forwardedHost = headers['x-forwarded-host']
  return { forwardedHost }
}

// todo(fernando.cervera): unify Unauth with Auth2
// err workaround for https://github.com/vercel/next.js/issues/8592

// eslint-disable-next-line react/prop-types
const MyApp = ({ Component, pageProps, err, member, metadata, experiments }) => {
  const modalContainer = useContainer('10')

  return (
    <Auth2 member={member || getSessionMember()}>
      <ABtestProvider experiments={experiments}>
        {/* eslint-disable-next-line react/prop-types */}
        <Unauth host={metadata?.forwardedHost}>
          <ThirdPartyScripts />
          <MessageCenterProvider>
            <ModalManagerProvider container={modalContainer}>
              <Component {...pageProps} err={err} />
            </ModalManagerProvider>
          </MessageCenterProvider>
        </Unauth>
      </ABtestProvider>
    </Auth2>
  )
}

// todo(fernando.cervera): consider adding this on each page it needs it instead of globally
MyApp.getInitialProps = async (appContext) => {
  const member = getHeaderMember(appContext.ctx.req?.headers)
  const metadata = getHeadersMetadata(appContext.ctx.req?.headers)
  const experiments = await getExperiments(member?.memberId, member?.siteId)

  return { member, metadata, experiments }
}

export default MyApp
